import { render, staticRenderFns } from "./EventOrganizerList.vue?vue&type=template&id=2c8055ef"
import script from "./EventOrganizerList.js?vue&type=script&lang=js&external"
export * from "./EventOrganizerList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports